import { lazy } from 'react';
import { authRoles } from 'app/auth';

const UpgradesPage = lazy(() => import('./UpgradesPage'));

const HealtheraProConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        topBanner: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'healthera-pro',
      element: <UpgradesPage />,
    },
  ],
};

export default HealtheraProConfig;
